import DialogLoading from '~/components/dialog/loading/DialogLoading.vue';
import DialogError from '~/components/dialog/error/DialogError.vue';

export const useDialogProfileSync = () => {
  const dialog = useDialogStore();

  const syncStore = useSyncStore();

  const progress = ref<number>(0);

  const _onLoadEventCancel = () => {
    _removeListeners();
    close();
  };
  const _onLoadEventComplete = () => {
    _removeListeners();
    close();
  };
  const _onLoadEventStart = () => {
    open();
  };
  const _onLoadEventProgress = (e) => {
    progress.value = e.progress;
  };

  const _addListeners = () => {
    syncStore.loadedEventCancel.on(_onLoadEventCancel);
    syncStore.loadedEventComplete.on(_onLoadEventComplete);
    syncStore.loadedEventStart.on(_onLoadEventStart);
    syncStore.loadedEventProgress.on(_onLoadEventProgress);
  };
  const _removeListeners = () => {
    syncStore.loadedEventCancel.off(_onLoadEventCancel);
    syncStore.loadedEventComplete.off(_onLoadEventComplete);
    syncStore.loadedEventStart.off(_onLoadEventStart);
    syncStore.loadedEventProgress.off(_onLoadEventProgress);
  };

  _addListeners();

  const open = () => {
    dialog.lockOnSystemLevel();
    dialog.open(DialogLoading, {
      level: DialogLevel.System,
      label: useNuxtApp().$i18n.t('installation.popin.updatingContent'),
      progress,
    });
  };

  const close = () => {
    dialog.unlock();
    dialog.close();
  };

  const error = (e) => {
    dialog.open(DialogError, {
      level: DialogLevel.System,
      label: useNuxtApp().$i18n.t('installation.popin.updatingFailure'),
    });
  };

  return {
    open,
    close,
    error,
  };
};
